import { telemetryIncrementAction } from 'core-events/actions';
import { JSX, useState } from 'react';
import { SearchFilterContentTypes, SearchOption } from 'search-gateway-client';

import BackgroundVideo from '../elements/BackgroundVideo';
import ProminentSearchLegacyContainer from '../elements/ProminentSearchLegacyContainer';
import { BuilderState } from '../types/shared';
import getTrendingTagLinks from '../utils/getTrendingTagLinks';

const imagesUrl = process.env.NEXT_PUBLIC_ASSET_PATH || '/images';

export interface Props {
    headingFirstLine?: string;
    headingSecondLine?: string;
    trendingTags?: string;
    contentTypes: SearchOption[];
    builderState: BuilderState;
}

function HomepageProminentSearch({
    headingFirstLine = 'Get Unlimited',
    headingSecondLine = 'Stock Media',
    trendingTags = 'Documentary,Love,Sport',
    contentTypes,
    builderState = {},
}: Props): JSX.Element {
    const [contentType, setContentType] = useState<SearchFilterContentTypes>(
        SearchFilterContentTypes.All_videos_content_type,
    );
    const currentIndex = contentTypes.findIndex(({ id }) => id === contentType);

    const isMobile = builderState?.state?.device === 'mobile';

    const eventTrackingForProminentSearch = () => {
        void telemetryIncrementAction('homepagesearch.trending_keyword_click');
    };

    return (
        <div className="relative h-[25rem] md:h-[40rem]">
            {/*Background*/}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden bg-gray-900">
                <div className="carousel overflow-hidden w-full h-full">
                    <div
                        className="carousel-content transition-all h-full whitespace-nowrap"
                        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                    >
                        {!isMobile &&
                            contentTypes?.map(({ videoSrc, posterSrc }, idx) => (
                                <BackgroundVideo
                                    videoSrc={videoSrc as string}
                                    idx={idx}
                                    key={idx}
                                    posterSrc={posterSrc}
                                />
                            ))}
                    </div>
                </div>
            </div>
            {/*Header Container*/}
            <div className="justify-center flex w-full relative z-10 m-auto">
                <div className="gap-y-16 max-w-screen-2xl grid grid-cols-12 pt-8 px-4 md:pt-40 md:px-12 lg:px-24 lg:pt-40">
                    {/*Header*/}
                    <div className="justify-center flex flex-col col-span-full px-2 md:px-4 lg:px-4">
                        {/*Header Text*/}
                        <div className="justify-center flex flex-col pb-3 md:pb-6 lg:pb-6">
                            <h1 className="text-white text-4xl mb-0 ppro-sm:text-4xl md:text-7xl lg:text-7xl">
                                {headingFirstLine}
                                <br />
                                {headingSecondLine}
                            </h1>
                        </div>
                        <div id="unifiedNav-search-app" className="prominent-search-bar">
                            <ProminentSearchLegacyContainer
                                imagesUrl={imagesUrl}
                                contentTypes={contentTypes}
                                contentType={contentType}
                                setContentType={setContentType}
                                showDropdown={false}
                            />
                        </div>
                        <div className="flex pt-6 pb-8 md:pb-24 lg:pb-24">
                            <p className="pr-1 text-white text-sm mobile-md:text-base ppro-sm:text-base md:text-base lg-text-base">
                                Trending:
                            </p>
                            {trendingTags.split(',').map((tag, idx) => (
                                <a
                                    className="homepage-trending text-white text-sm mobile-md:text-base ppro-sm:text-base md:text-base lg-text-base font-bold underline pr-1 underline-offset-5"
                                    href={getTrendingTagLinks(tag.toLowerCase().replace(/\s/g, '-'), contentType)}
                                    onClick={eventTrackingForProminentSearch}
                                    key={tag}
                                >
                                    {tag}
                                    {idx === trendingTags.split(',').length - 1 ? '' : ','}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomepageProminentSearch;
